import VwSonucizlememuracaatDTO from "src/models/SonucIzleme/VwSonucizlememuracaatDTO";
import api from "../core/api";
import SonucIzlemeMuracaatListeRequest from "src/models/SonucIzleme/SonucIzlemeMuracaatListeRequest";
import SonucIzlemeIndirilenRaporResponse from "src/models/SonucIzleme/SonucIzlemeRaporIndirResponse";
import SonucIzlemeRaporIndirRequest from "src/models/SonucIzleme/SonucIzlemeRaporIndirRequest";

const controllerName = "SonucIzleme";
export const SonucIzlemeApi = api.injectEndpoints({
    endpoints: (builder) => ({
        SonucIzlemeMuracaatListesi: builder.query<Array<VwSonucizlememuracaatDTO>, SonucIzlemeMuracaatListeRequest>({
            query: (request) => ({
                url: `${controllerName}/SonucIzlemeMuracaatListesi`,
                method: "POST",
                body: JSON.stringify(request)
            }),
            providesTags: ["SonucIzlemeMuracaatListesi"],
        }),
        SonucIzlemePatolojiTopluRaporIndir: builder.mutation<SonucIzlemeIndirilenRaporResponse, Array<SonucIzlemeRaporIndirRequest>>({
            query: (request) => ({
                url: `${controllerName}/SonucIzlemePatolojiTopluRaporIndir`,
                method: "POST",
                body: JSON.stringify(request),
                cache: "no-cache"
            }),
            invalidatesTags: ["SonucIzlemeMuracaatListesi"]
        }),
        SonucIzlemeLaboratuvarTopluRaporIndir: builder.mutation<SonucIzlemeIndirilenRaporResponse, Array<SonucIzlemeRaporIndirRequest>>({
            query: (request) => ({
                url: `${controllerName}/SonucIzlemeLaboratuvarTopluRaporIndir`,
                method: "POST",
                body: JSON.stringify(request),
                cache: "no-cache"
            }),
            invalidatesTags: ["SonucIzlemeMuracaatListesi"]
        }),
        SonucIzlemePatolojiPdfRaporGoruntule: builder.query<string, {raporId: number}>({
            query: (request) => ({
                url: `${controllerName}/SonucIzlemePatolojiPdfRaporGoruntule`,
                method: "GET",
                params: request
            }),
        }),
    }),
});

export const {
    useSonucIzlemeMuracaatListesiQuery,
    useSonucIzlemePatolojiTopluRaporIndirMutation,
    useSonucIzlemeLaboratuvarTopluRaporIndirMutation,
    useLazySonucIzlemePatolojiPdfRaporGoruntuleQuery,
    
} = SonucIzlemeApi;